import ErrorFallback from "@/components/ui/errors/ErrorFallback";

export const SentryErrorFallback = ({ error, componentStack, resetError }) => {
  return <ErrorFallback error={error} handleResetError={resetError} />;
};

export default SentryErrorFallback;
